import { Banner } from './Banner';
import { depositBannerState } from '../../states';

export const DepositBanner = depositBannerState(Banner);
